import { render, staticRenderFns } from "./sysMajor.vue?vue&type=template&id=1b553d3a&"
import script from "./sysMajor.vue?vue&type=script&lang=js&"
export * from "./sysMajor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports